/* eslint-disable import/extensions */
import { HomePage } from 'pages/HomePage';
import { useRoutes } from 'react-router';
import { ProductTypePage } from 'pages/ProductTypePage';
import { PATHS } from './constants';

export const NavigateList = () => {
	const routes = useRoutes([
		{
			path: PATHS.HOME_PAGE,
			element: <HomePage />,
		},
		{
			path: PATHS.PRODUCT_TYPE_PAGE,
			element: <ProductTypePage />,
		},
		{
			path: '*',
			element: <HomePage />,
		},
	]);
	return routes;
};
